"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = exports.default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "m12.417 11.634 3.861 3.541c.34.31.362.837.052 1.177a.842.842 0 0 1-1.177.05l-4.133-3.787a.833.833 0 0 1-.27-.615V7.417a.833.833 0 0 1 1.667 0v4.217Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c-.006-5.52-4.48-9.994-10-10Zm0 18.333A8.333 8.333 0 1 1 20.333 12 8.342 8.342 0 0 1 12 20.333Z"
})), "0 0 24 24", "Clock");